// extracted by mini-css-extract-plugin
export var dark = "homeSectionWorks-module--dark--10254";
export var light = "homeSectionWorks-module--light--bd34b";
export var modalVideo = "homeSectionWorks-module--modal-video--c27e1";
export var modalVideoBody = "homeSectionWorks-module--modal-video-body--9437a";
export var modalVideoCloseBtn = "homeSectionWorks-module--modal-video-close-btn--9e5b3";
export var modalVideoEffectExit = "homeSectionWorks-module--modal-video-effect-exit--d87ed";
export var modalVideoInner = "homeSectionWorks-module--modal-video-inner--5648c";
export var modalVideoMovieWrap = "homeSectionWorks-module--modal-video-movie-wrap--7b732";
export var section = "homeSectionWorks-module--section--2a8c3";
export var title = "homeSectionWorks-module--title--ebb3a";
export var titleLine = "homeSectionWorks-module--title-line--db786";
export var titleLink = "homeSectionWorks-module--title-link--51e6e";
export var titleText = "homeSectionWorks-module--title-text--0da12";
export var work = "homeSectionWorks-module--work--e39e5";
export var workContent = "homeSectionWorks-module--work-content--89e8f";
export var workImage = "homeSectionWorks-module--work-image--1e8da";
export var workLink = "homeSectionWorks-module--work-link--d3d55";
export var workText = "homeSectionWorks-module--work-text--6e320";
export var workTitle = "homeSectionWorks-module--work-title--d730b";